<template>
  <cv-button type="button" v-bind="$attrs" @click="handleClick">
    <slot name="icon" />
    <span>{{ btnLabel }}</span>
  </cv-button>
</template>

<script setup lang="ts">
interface Props {
  btnLabel?: string;
}

const emit = defineEmits<{
  click: [];
}>();

const { btnLabel = "" } = defineProps<Props>();

function handleClick() {
  emit("click");
}
</script>
